export interface Stat {
    answered: number;
    total: number;
    sent: number;
    notSent: number;
    read: number;
    notRead: number;
    unsubscribed: number;
}

export const initialStat: Readonly<Stat> = {
    answered: 0,
    total: 0,
    sent: 0,
    notSent: 0,
    read: 0,
    notRead: 0,
    unsubscribed: 0,
};
